import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PaintIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2ZM5.5 10.5A.5.5 0 0 1 6 10h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-4Z"
		/>
		<path
			fill="currentColor"
			d="M13 4V2.586A1.5 1.5 0 0 1 14 4v2.569a1.5 1.5 0 0 1-1.393 1.496l-5.143.367a.5.5 0 0 0-.464.5V9H6v-.069a1.5 1.5 0 0 1 1.393-1.496l5.143-.367a.5.5 0 0 0 .464-.5V4Z"
		/>
	</svg>
))
